import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'sign-up-instructor',
  templateUrl: './sign-up-instructor.component.html',
  styleUrls: ['./sign-up-instructor.component.css']
})
export class SignUpInstructorComponent implements OnInit {

  email: string;
  password:string;
  nombre: string;
  docName: string;

  constructor(
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
  }

  signUpInstructor(){
    this.authService.SignUpInstructor(this.email, this.password, this.nombre, this.docName)
  }
}
